import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DomuComponent} from './domu.component';

const routes: Routes = [
	{
		path: '',
		component: DomuComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)]
})
export class DomuRoutingModule {
}
